// Utility for preloading routes on user interaction
export const preloadRoute = (routeName: string) => {
  switch (routeName) {
    case 'about':
      return import('../components/About');
    case 'privacy':
      return import('../components/PrivacyPolicy');
    case 'terms':
      return import('../components/TermsOfService');
    case 'contact':
      return import('../components/ContactUs');
    case 'error':
      return import('../components/ErrorPage');
    case 'faq':
      return import('../components/FAQ');
    case 'support':
      return import('../components/Support');
    case 'blog':
      return import('../components/BlogList');
    case 'blogPost':
      return import('../components/BlogPost');
    default:
      return Promise.resolve();
  }
};

// Preload critical routes on hover/focus
export const preloadOnInteraction = (routeName: string) => {
  const preload = () => preloadRoute(routeName);
  
  return {
    onMouseEnter: preload,
    onFocus: preload
  };
};